<div class="main-photo-edit-dialog">
  <!-- Cropper: only when editing main photo (performerId) and file selected -->
  <div *ngIf="showCropper && preview" class="main-photo-edit-dialog__cropper-wrap">
    <img
      #cropImage
      [src]="preview"
      alt="Обрезка"
      class="main-photo-edit-dialog__cropper-img"
      (load)="onCropImageLoad()"
    />
  </div>
  <!-- Static preview when no cropper -->
  <div *ngIf="!showCropper && preview" class="main-photo-edit-dialog__preview-wrap">
    <img [src]="preview" alt="Основное фото" class="main-photo-edit-dialog__preview" />
  </div>
  <div *ngIf="!preview" class="main-photo-edit-dialog__placeholder">
    <i class="pi pi-image"></i>
    <p>Фото не загружено</p>
  </div>

  <div class="main-photo-edit-dialog__actions">
    <input
      type="file"
      #fileInput
      class="main-photo-edit-dialog__file-input"
      accept="image/png,image/jpeg,image/jpg"
      (change)="onFileChange($event.target.files, $event.target)"
    />
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="fileInput.click()" [disabled]="loading">
      {{ preview ? 'Заменить' : 'Загрузить' }}
    </button>
    <button *ngIf="preview" type="button" class="ui-buttons ui-buttons__light-small" (click)="remove()" [disabled]="loading">
      Удалить
    </button>
  </div>
  <p class="txt-caption main-photo-edit-dialog__hint">
    {{ performerId && showCropper ? 'Выберите область для основного фото. Можно менять размер и пропорции рамки.' : 'До 1 Мб. Допустимые форматы: PNG, JPG, JPEG.' }}
  </p>
  <div class="main-photo-edit-dialog__footer">
    <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onCancel()">Отмена</button>
    <ng-container *ngIf="performerId">
      <button type="button" class="ui-buttons ui-buttons__blue-small" (click)="onApply()" [disabled]="!isApplyEnabled">
        Применить
      </button>
    </ng-container>
    <button *ngIf="!performerId" type="button" class="ui-buttons ui-buttons__blue-small" (click)="onDone()">Готово</button>
  </div>
</div>
